import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import {
  asyncGetItem,
  asyncGetList,
} from "@/setup/flexbiz-api-provider/coreFunction";
import processKeys from "../queryKeys/processKeys";
import { collection_name, staleTime } from "@/types/projectConsts";

/* ------------------------------ DETAIL ------------------------------ */

export const getProcess = async (slug: string, locale = "vi") => {
  if (!slug) return null;

  try {
    const result = await asyncGetItem<any>({
      collection_name: collection_name.NEWS,
      options: {
        shared: true,
        condition: {
          slug,
          ngon_ngu: locale,
        },
      },
    });

    return result?.[0] || null;
  } catch (error) {
    console.error("getProcess failed:", error);
    return null;
  }
};

export const useGetProcess = (slug: string, locale = "vi") => {
  return useQuery({
    queryKey: processKeys.detail(slug, locale),
    queryFn: () => getProcess(slug, locale),
    staleTime: staleTime.DEFAULT,
    enabled: !!slug,
  });
};

/* ------------------------------ LIST ------------------------------ */

export const getProcesses = async (options: any = {}, locale = "vi") => {
  const data = await asyncGetList({
    collection_name: collection_name.NEWS,
    options: {
      page: 1,
      limit: process.env.NEWS_LOADING_LIMIT,
      sort: { date_created: -1 },
      ...options,
      condition: {
        ngon_ngu: locale,
        shared: true,
        loai_tin_tuc: {
          $in: ["Tiến độ dự án"],
        },
        ...(options?.condition || {}),
      },
    },
  });
  return data;
};

export const useGetProcesses = (options: any, locale = "vi") => {
  return useQuery({
    queryKey: processKeys.list({ ...options, ngon_ngu: locale }),
    queryFn: () => getProcesses({ ...options, ngon_ngu: locale }),
    staleTime: staleTime.DEFAULT,
  });
};
